"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOrderBuyAgainClick = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackOrderBuyAgainClick(previous_order_id) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: 'Order overview buy again',
        click_text: 'Noch einmal kaufen',
        previous_order_id,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: 'Orders Buy Again',
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackOrderBuyAgainClick = trackOrderBuyAgainClick;
//# sourceMappingURL=trackOrderBuyAgainClick.js.map